import properties from 'resources/constants/properties.json';

// client environments where users log in only through the client's sso - our own passwords are not used there
const SSO_ONLY_STAGENAMES = ["ecosdev", "ecosprod", "xpansivdev", "xpansivprod"]

export default {
  CORE_TASKS: "Core Tasks",
  IS_SSO_ONLY_STAGE: SSO_ONLY_STAGENAMES.includes(properties.stageName)
}
